/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import Switch from 'components/atoms/switch';
import {
  createUserPreference,
  destroyUserPreference,
} from 'store/modules/my_account_store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { MyAccountState } from 'store/modules/my_account_store/types';

const NotificationDocuments = () => {
  const dispatch = useDispatch();
  const { my_account } = useSelector<ApplicationState, MyAccountState>(
    (state) => state.session.my_account,
  );

  const checkedPush = (userPreferenceId: number) => {
    const action = my_account?.documents_push_notification === false ? 'create' : 'destroy';

    if (action === 'destroy') {
      dispatch(destroyUserPreference(userPreferenceId));
    }
    if (action === 'create') {
      dispatch(createUserPreference(userPreferenceId));
    }
  };
  const checkedPushEmail = (userPreferenceId: number) => {
    const action = my_account?.documents_email_notification === false ? 'create' : 'destroy';
    if (action === 'destroy') {
      dispatch(destroyUserPreference(userPreferenceId));
    }
    if (action === 'create') {
      dispatch(createUserPreference(userPreferenceId));
    }
  };

  const changeUserPreference = (userPreferenceId: number) => {
    const action = my_account?.documents_notification === false ? 'create' : 'destroy';
    if (action === 'destroy') {
      dispatch(destroyUserPreference(userPreferenceId));
    }
    if (action === 'create') {
      dispatch(createUserPreference(userPreferenceId));
    }
  };

  return (
    <div className="row align-items-center border-0 py-3 text-md-right text-center pl-0">
      <div className="col-12 col-md-3 text-left pr-0">
        <div className="row rounded mx-1 mb-2 bg-light">
          <p className="font-weight-bold p-1 text-white text-center rounded-top mb-2 w-100 bg-secondary">
            Ativar notificações
          </p>
          <div className="col-md-12">
            <small>Receba avisos de vencimento dos documentos.</small>
          </div>
          <div className="col-md-12">
            <Switch
              handleChange={() => changeUserPreference(14)}
              checked={my_account?.documents_notification}
            />
          </div>
          <div className="col-12 mt-3">
            <dl>
              <dt>Tipo de Notificação</dt>
              <dd>
                <label className="control control-checkbox mr-2">
                  <input
                    type="checkbox"
                    className="mr-2"
                    checked={my_account?.documents_email_notification}
                    disabled={false}
                    onChange={() => checkedPushEmail(15)}
                  />{' '}
                  E-mail
                </label>
                <label className="control control-checkbox">
                  <input
                    type="checkbox"
                    className="mr-2"
                    checked={my_account?.documents_push_notification}
                    disabled={false}
                    onChange={() => checkedPush(16)}
                  />
                  Push Notification
                </label>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationDocuments;
